import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBlock = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-298.67 -348.44 2133.33 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1312 643Q1312 804 1225 938L471 185Q608 96 768 96Q879 96 979.5 139.5Q1080 183 1153.0 256.0Q1226 329 1269.0 430.5Q1312 532 1312 643ZM313 344 1068 1098Q933 1189 768 1189Q620 1189 495.0 1116.0Q370 1043 297.0 917.0Q224 791 224 643Q224 481 313 344ZM1475.0 942.5Q1536 800 1536.0 643.0Q1536 486 1475.0 343.0Q1414 200 1311.5 97.0Q1209 -6 1066.5 -67.0Q924 -128 768.0 -128.0Q612 -128 469.5 -67.0Q327 -6 224.5 97.0Q122 200 61.0 343.0Q0 486 0.0 643.0Q0 800 61.0 942.5Q122 1085 224.5 1188.0Q327 1291 469.5 1352.0Q612 1413 768.0 1413.0Q924 1413 1066.5 1352.0Q1209 1291 1311.5 1188.0Q1414 1085 1475.0 942.5Z"
	})
});
export default SvgBlock;
